export class UpdateCalibration{
    id:number;
    procedureId:number;
    personId:number;
    calibrationDate:Date;
    status:number;
    environmentalConditionId:number;
    accreditationOrganization:number;
    isPlace:boolean;
    acceptanceDate?:Date;
}

/*
{
  "id": 0,
  "procedureId": 0,
  "personId": 0,
  "calibrationDate": "2025-02-19T13:04:31.498Z",
  "status": 0,
  "environmentalConditionId": 0,
  "accreditationOrganization": 0,
  "isPlace": true,
  "acceptanceDate": "2025-02-19T13:04:31.498Z"
}
*/